import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class TabItem extends Component {
    render() {
        return (
            <>
                {this.props.children}
            </>
        );
    }
}

TabItem.propTypes = {
    label: PropTypes.string,
    hidden: PropTypes.bool,
    disabled: PropTypes.bool,
    isTable: PropTypes.bool,
    children: PropTypes.node,
    __TYPE: PropTypes.string,
};

TabItem.defaultProps = {
    __TYPE: 'TabItem',
};